import type { TmsEventStream, TmsEventStreamPage } from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

/**
 * One page request against a TMS event stream: history mode without `since` (newest `occurredAt` first), delta mode
 * with it (oldest `createdAt` first). `cursor` continues a page in the same mode.
 */
export type TmsEventStreamQuery = {
  workspaceId: string;
  stream: TmsEventStream;
  limit?: number;
  cursor?: string;
  since?: string;
};

/**
 * Reads one page of a workspace's TMS event stream.
 *
 * No protocol version is pinned: the client speaks every version the generated union carries, and skew is handled
 * by shipping the client ahead of the backend (SVS-3884).
 */
export function listTmsEventStream(transport: Transport, query: TmsEventStreamQuery): Promise<TmsEventStreamPage> {
  return operations.getWorkspacesTmsEvents(transport, query);
}
